import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectPeriocidadSatItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarPeriocidades = debounce(this.buscarPeriocidades.bind(this), 300);
  }

  componentDidMount() {
    this.buscarPeriocidades('');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value) {
        const encontrado = this.state.opciones.find(
          (p) => p._id.toString() === this.props.value.toString()
        );
        if (!encontrado) {
          this.buscarPeriocidades(this.props.value || '');
        }
      }
    }
  }

  async buscarPeriocidades(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "periodicidadPagoSat/selectPeriodicidadPagoSatItem",
        {
          query: texto,
          values: this.props.value,
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.periodicidades || [],
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar periocidades SAT:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const {
      noBuscar,
      mode,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarPeriocidades,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: "center", padding: "8px" }}>
          <div style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}>
            Buscando periocidades...
          </div>
        </div>
      ) : this.state.primerCarga ? (
        "No se encontraron periocidades"
      ) : null,
      loading: this.state.cargando,
    };

    if (mode === "multiple") {
      propsNuevas.maxTagCount = "responsive";
    }

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? (fondoBlanco ? "white" : "white") : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0, 0, 0, 0.1)",
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={450}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const periocidad = this.state.opciones.find((p) => p._id === value);
          this.props.onChange(value, periocidad);
        }}
        placeholder={
          this.state.cargando && !this.state.primerCarga
            ? "Cargando..."
            : placeholder
        }
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((periocidad) => (
          <Option key={periocidad._id} value={periocidad._id}>
            {periocidad.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectPeriocidadSatItem;